<template>
  <footer class="v-footer footer container">
    <div class="row">
      <div class="col-6 col-md-2 pb-3">
        <router-link class="border-bottom" to="/services">Наши услуги</router-link>
      </div>
      <div class="col-6 col-md-2 pb-3">
        <router-link class="border-bottom" to="/terms-of-service">Договор-оферта</router-link>
      </div>
      <div class="col-12 col-md-5 pb-3">
        <div class="payment-logos">
          <img src="@/assets/img/visa.png">
          <img src="@/assets/img/mastercard.png">
          <img src="@/assets/img/yandex-money.png">
        </div>
      </div>
      <div class="col-12 col-md-3 pb-3 text-center text-muted font-weight-light">
        © 2019 - 2020 Paysim
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'v-footer',
};
</script>
